/** This example uses ng-primitives styles, which are imported from ng-primitives/example-theme/index.css in the global styles file **/
import { NumberInput } from '@angular/cdk/coercion';
import { Component, input, numberAttribute } from '@angular/core';
import { NgpProgress, NgpProgressIndicator, NgpProgressTrack } from 'ng-primitives/progress';

@Component({
  selector: 'joii-progress-bar',
  hostDirectives: [
    {
      directive: NgpProgress,
      inputs: ['ngpProgressValue:value', 'ngpProgressMax:max', 'ngpProgressValueLabel:valueLabel'],
    },
  ],
  imports: [NgpProgressIndicator, NgpProgressTrack],
  styles: `
    [ngpProgress] {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-row-gap: 0.5rem;
      width: 200px;
      box-sizing: border-box;
      padding: 0.5rem;
    }

    [ngpProgressLabel] {
      color: var(--ngp-text-emphasis);
      font-size: 14px;
      font-weight: 600;
    }

    [ngpProgressValue] {
      color: var(--ngp-text-secondary);
      font-size: 14px;
      font-weight: 500;
      text-align: right;
      grid-column-start: 2;
      text-align: end;
    }

    [ngpProgressTrack] {
      grid-column: 1 / 3;
      position: relative;
      height: 6px;
      width: 100%;
      overflow: hidden;
      border-radius: var(--Vetai-Radius-1);
      background-color: var(--Vetai-Backgrounds--Tint_2);
    }

    [ngpProgressIndicator] {
      height: 100%;
      border-radius: var(--Vetai-Radius-1);
      background-color: var(--Vetai-Inline_links_and_info--Default);
      transition: width 150ms cubic-bezier(0.4, 0, 0.2, 1);
    }
  `,
  template: `
    <div ngpProgressTrack>
      <div ngpProgressIndicator></div>
    </div>
  `,
})
export class ProgressBarComponent {
  /**
   * The value of the progress bar.
   */
  readonly value = input<number, NumberInput>(0, {
    transform: numberAttribute,
  });
}
